import React from 'react';
import { Link } from 'react-router-dom';

type Variant = 'primary' | 'ghost';

interface BaseProps {
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
}

type AnchorProps = BaseProps & {
  to: string;
  external?: boolean;
  onClick?: never;
  type?: never;
};

type ButtonProps = BaseProps & {
  to?: never;
  external?: never;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
};

type Props = AnchorProps | ButtonProps;

const Btn: React.FC<Props> = (props) => {
  const { variant = 'primary', children, className = '' } = props;
  const cls = `ds-btn ds-btn--${variant} ${className}`.trim();

  if ('to' in props && props.to) {
    if (props.external) {
      return (
        <a className={cls} href={props.to} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      );
    }
    return (
      <Link className={cls} to={props.to}>
        {children}
      </Link>
    );
  }

  const { onClick, type = 'button' } = props as ButtonProps;
  return (
    <button className={cls} onClick={onClick} type={type}>
      {children}
    </button>
  );
};

export default Btn;
